import {
  Box,
  Table,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
  TablePagination,
  Avatar,
} from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../common/styles";
import { useAppSelector } from "../../app/hooks";
import View from "../../assets/icon/view.svg";
import AppoimentView from "../../assets/icon/appointmentview.svg";
import CustomIcon from "../common/CustomIcon";
import { useState } from "react";

import { BASE_API_URL } from "../../api";
import AppModal from "../common/AppModal";
import PatientsEditModal from "./patientsEditModel";
import { useNavigate } from "react-router-dom";
import { PATIENT_PROFILE_SCREEN_ROUTE } from "../../routes";

function PatientsScreen(props: any) {
  const { patients }: any = useAppSelector((state) => state.speciality);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [patientId, setpatientId] = useState({});
  const [filtered, setFiltered] = useState(patients?.data?.patients_data);
  const [openModals, setOpenModals] = useState(false);
  const handleViewModal = () => setOpenModals(true);
  const handleCloseModals = () => setOpenModals(false);
  const navigate = useNavigate();
  const gotoPatientProfile = (dId: string) => {
    navigate(`${PATIENT_PROFILE_SCREEN_ROUTE}/${dId}`);
  };
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const filterAll = (value: any) => {
    const res = patients?.data?.patients_data?.filter((pati: any) =>
      Object.values(pati)
        .join(" ")
        .toLocaleLowerCase()
        .includes(value.toLocaleLowerCase())
    );
    setFiltered(res);
  };
  const filterName = (name: any) => {
    const res = patients?.data?.patients_data.filter((pati: any) => {
      const lower_case_name = pati.name.toLocaleLowerCase();
      return lower_case_name.includes(name.toLocaleLowerCase());
    });

    setFiltered(res);
  };
  const filterPhoneNo = (phoneNo: any) => {
    const res = patients?.data?.patients_data.filter((pati: any) => {
      const lower_case_no = pati.phone_number;
      return lower_case_no?.includes(phoneNo?.toLocaleLowerCase());
    });

    setFiltered(res);
  };
  function Filter(field: string, value: string) {
    switch (field) {
      case "Name":
        filterName(value);
        break;
      case "Phone No":
        filterPhoneNo(value);
        break;
      default:
        return filterAll(value);
    }
  }
  return (
    <TableContainer>
      <Box sx={{ minWidth: 1050 }}>
        <Table>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Id</StyledTableCell>
              <StyledTableCell>Profile Picture</StyledTableCell>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Phone Number</StyledTableCell>
              <StyledTableCell>Created </StyledTableCell>
              <StyledTableCell>Gender</StyledTableCell>
              <StyledTableCell>DOB</StyledTableCell>
              <StyledTableCell>Age</StyledTableCell>
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {filtered
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((patient: any) => (
                <StyledTableRow hover key={patient.id}>
                  <StyledTableCell>{patient.id}</StyledTableCell>
                  <StyledTableCell>
                    <Avatar
                      src={`${BASE_API_URL}/api/admin/patients/image?patient_id=${patient.id}`}
                      sx={{ mr: 2 }}
                    ></Avatar>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Box
                      sx={{
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Typography color="textPrimary" variant="body1">
                        {patient.name}
                      </Typography>
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell>{patient.phone_number}</StyledTableCell>
                  <StyledTableCell>
                    {patient.created_on.slice(0, -14)}
                  </StyledTableCell>
                  <StyledTableCell>{patient.phoneNo}</StyledTableCell>
                  <StyledTableCell>
                    {patient.dob?.slice(0, -14)}
                  </StyledTableCell>
                  <StyledTableCell>{patient.age}</StyledTableCell>
                  <StyledTableCell>{patient.email}</StyledTableCell>
                  <StyledTableCell>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CustomIcon
                        style={{
                          cursor: "pointer",
                        }}
                        IconType={AppoimentView}
                        title="Appoiment View"
                        onClick={() => {
                          setpatientId(patient);
                          handleViewModal();
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        marginLeft: "50px",
                        marginTop: "-25px",
                      }}
                    >
                      <CustomIcon
                        IconType={View}
                        title="Preview"
                        onClick={() => gotoPatientProfile(patient.id)}
                      />
                    </Box>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            <AppModal
              title="Appointments Details"
              open={openModals}
              handleClose={handleCloseModals}
              fullScreen={false}
            >
              <PatientsEditModal Data={patientId} />
            </AppModal>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              colSpan={3}
              count={patients?.data?.patients_data?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
  );
}
export default PatientsScreen;
